export const SearchContainer = () => <div id="search-container" />
export const ModalContainer = () => <div id="modal-container" />
export const PortalContainer = () => <div id="portal-root" />
